<div class="load-banner">
    <c-spinner color="light" />
</div>
